import { createSwitchNavigator, createStackNavigator } from 'react-navigation'
import { Platform } from 'react-native'
import LoginScreen from '../components/Screens/Login'
import WaitingRoomScreen from '../components/Screens/WaitingRoom'
import AuthLoadingScreen from '../components/Screens/AuthLoading'
import ErrorPage from '../components/Screens/ErrorPage'
import DiagnosePage from '../components/Screens/DiagnosePage'

import AppStack from '../components/Screens'

const AuthStack = createStackNavigator({
  AuthLoading: AuthLoadingScreen,
  Login: LoginScreen,
  WaitingRoom: WaitingRoomScreen
}, {
  headerMode: 'none',
  initialRouteName: 'AuthLoading'
})

export default createSwitchNavigator(
  {
    App: AppStack,
    Auth: AuthStack,
    Error: ErrorPage,
    Diagnose: DiagnosePage
  },
  {
    initialRouteName: Platform.OS === 'web' ? window.location.pathname.toLowerCase() === '/diagnose' ? 'Diagnose' : 'Auth' : 'App'
  }
)
